/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserPreferenceListRequest {
    getFixupPrototypeFunction() { return UserPreferenceListRequest.fixupPrototype; }

    static newInstance(model: Partial<UserPreferenceListRequest>): UserPreferenceListRequest {
        let obj = Object.assign(new UserPreferenceListRequest(), model);
        UserPreferenceListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserPreferenceListRequest>): UserPreferenceListRequest {
        if (!model) return null;
        return UserPreferenceListRequest.newInstance(<UserPreferenceListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserPreferenceListRequest) {
        if (!obj) return;

        models.UserPreferenceListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserPreferenceListRequest): boolean {
        Object.setPrototypeOf(obj, UserPreferenceListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Path of the user preference
     */
    path: string;

}
